<template>
  <div class="navigation driver">
    <v-list class="driver-nav-list">
      <v-list-item
        :to="`/drivers/${$route.params.driverId}/info`"
        active-class="active"
      >
        <v-list-item-content class="text-center">
          <div class="navigation-name">{{ $t('navigation.info') }}</div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        :to="`/drivers/${$route.params.driverId}/autos`"
        active-class="active"
      >
        <v-list-item-content class="text-center">
          <div class="navigation-name">{{ $t('navigation.autos') }}</div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        :to="`/drivers/${$route.params.driverId}/balance`"
        active-class="active"
      >
        <v-list-item-content class="text-center">
          <div class="navigation-name">{{ $t('navigation.balance') }}</div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        :to="`/drivers/${$route.params.driverId}/history`"
        active-class="active"
      >
        <v-list-item-content class="text-center">
          <div class="navigation-name">{{ $t('navigation.history') }}</div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        :to="`/drivers/${$route.params.driverId}/fines`"
        active-class="active"
      >
        <v-list-item-content class="text-center">
          <div class="navigation-name">{{ $t('fines.title') }}</div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        :to="`/drivers/${$route.params.driverId}/dtp`"
        active-class="active"
      >
        <v-list-item-content class="text-center">
          <div class="navigation-name">{{ $t('dtp.title') }}</div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        :to="`/drivers/${$route.params.driverId}/rating`"
        active-class="active"
      >
        <v-list-item-content class="text-center">
          <div class="navigation-name">{{ $t('driverRating.title') }}</div>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
export default {
  name: 'DriverNavigation',
};
</script>

<style lang="scss" scoped>
.navigation {
  &.driver {
    width: 100%;
    background: transparent;

    .driver-nav-list {
      display: flex;
      background: transparent;

      @media (max-width: (650px)) {
        display: block;
      }
    }
  }
}
</style>
